// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qt_a bik_sn bik_va","ForumSearch__img":"qt_b","ForumSearch__searchAdsAndShoppingAds":"qt_c","ForumSearch__results--empty":"qt_e"};